import QRCode from 'react-qr-code';
import { forwardRef } from 'react';
import BluebirdImage from '@/assets/images/bluebird-kirim.svg';
import dayjs from 'dayjs';

import './print.css';

interface IOrderPrintAwb {
  airwaybill: OrderResponse;
  qty: number;
  number: number;
}

const OrderPrintAwb = forwardRef<HTMLDivElement, IOrderPrintAwb>((props, ref) => {
  const { airwaybill, number, qty } = props;

  return (
    <div style={{ width: '100mm', height: '100m' }} className="text-[10px] justify-center items-center p-[2px] print-container" ref={ref}>
      <div className="border border-black mb-[2px] p-1 grid grid-cols-2 justify-between">
        <div className="flex">
          <div className="w-28">
            <img src={BluebirdImage} alt="bb-kirim" />
          </div>
        </div>
      </div>
      <div className="border border-black flex justify-center items-center mb-[2px] p-[2px]">
        <p className="font-bold">No. Resi : {airwaybill?.awb_number}</p>
      </div>

      <div className="grid grid-cols-3 gap-2 mb-[2px] border border-black">
        <div className="py-0 space-y-[1px] p-1 col-span-2">
          <div className="flex">
            <div className="font-bold w-1/2">Ref #</div>
            <div className="w-full">: {airwaybill?.order_reference_number}</div>
          </div>
          <div className="flex">
            <span className="font-bold w-1/2">Asal</span>
            <span className="w-full">: {airwaybill?.origin_name}</span>
          </div>
          <div className="flex">
            <span className="font-bold w-1/2">Tujuan</span>
            <span className="w-full">: {airwaybill?.destination_name}</span>
          </div>
          <div className="flex">
            <span className="font-bold w-1/2">Tanggal Order</span>
            <span className="w-full">: {dayjs(airwaybill?.order_date_time_utc).format('DD MM YYYY')}</span>
          </div>
          <div className="flex">
            <span className="font-bold w-1/2">Pengirim</span>
            <span className="w-full">: {airwaybill?.shipper_name}</span>
          </div>
          <div className="flex">
            <span className="font-bold w-1/2">Telp</span>
            <span className="w-full">: {airwaybill?.shipper_phone_number}</span>
          </div>
          <div className="flex">
            <span className="font-bold w-1/2">Layanan</span>
            <span className="w-full">: {airwaybill?.product_service_code}</span>
          </div>
          <div className="flex">
            <span className="font-bold w-1/2">Asuransi</span>
            <span className="w-full">: {airwaybill?.is_insurance ? 'Ya' : 'Tidak'}</span>
          </div>
        </div>
        <div className="space-y-1">
          <div className="flex justify-end">
            <div className="text-[29px] font-bold border-l border-b border-black p-1">{airwaybill?.destination_tlc}</div>
          </div>
          <div className="flex justify-end pr-1">
            <QRCode value={airwaybill?.awb_number || ''} size={70} />
          </div>
          <div className="flex justify-end pr-1 text-[7.5px]">
            {airwaybill?.awb_number}
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-2 border border-black px-1">
        <div className="space-y-[1px]">
          <div className="flex">
            <span className="font-bold w-1/4">Penerima</span>
            <span className="w-full">: {airwaybill?.consignee_name}</span>
          </div>
          <div className="flex">
            <span className="font-bold w-1/4">Telp</span>
            <span className="w-full">: {airwaybill?.consignee_phone_number}</span>
          </div>
          <div className="flex">
            <span className="font-bold w-1/4">Alamat</span>
            <span className="w-full">: {airwaybill?.destination_name}</span>
          </div>
          <div className="flex">
            <span className="font-bold w-1/4">Nama Produk</span>
            <span className="w-full">: {airwaybill?.parcel_type}</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-6 border-l border-b border-r border-black">
        <div className="col-span-1 border-r border-black">
          <div className="border-b border-black p-1 text-center">
            <p>Qty</p>
          </div>
          <div className="p-1 text-center">
            <p>Berat</p>
          </div>
        </div>
        <div className="col-span-1 border-r border-black">
          <div className="border-b border-black p-1 text-center">
            <p className="font-bold">1</p>
          </div>
          <div className="p-1 text-center">
            <p className="font-bold">{airwaybill?.parcel_weight} Kg</p>
          </div>
        </div>

        <div className="col-span-3 border-r border-black flex items-center justify-center p-1">
          <p className="font-bold">NON COD</p>
        </div>

        <div className="col-span-1 flex items-center justify-center p-1">
          <p className="font-bold">{number + 1} of {qty}</p>
        </div>
      </div>

      <div className="border-l border-b border-r border-black flex justify-center items-center mb-1 p-[12px]">
        <p className="font-bold">Intruksi: {airwaybill?.courier_note || '-'}</p>
      </div>
    </div>
  );
});

export default OrderPrintAwb;
